import { render, staticRenderFns } from "./QuantityInput.vue?vue&type=template&id=87978554&scoped=true"
import script from "./QuantityInput.vue?vue&type=script&lang=js"
export * from "./QuantityInput.vue?vue&type=script&lang=js"
import style0 from "./QuantityInput.vue?vue&type=style&index=0&id=87978554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87978554",
  null
  
)

export default component.exports